// SYNCED FROM: VidaReactNative/src/constants/lob.ts — keep in sync. See SYNC.md.
import { getConfig } from '@/modules/runtimeConfig';

/**
 * Lob publishable key — used for client-side US address verification.
 *
 * We use the live key in every environment because Lob's test key does not
 * actually verify addresses — it only validates request shape and returns
 * canned responses keyed off special `primary_line` values.
 *
 * See: https://help.lob.com/account-management/api-keys
 *
 * A function rather than the `const` it used to be. The key comes from runtime config
 * now, which `OnboardingRoot` publishes during render — a module-scope `const` would be
 * evaluated when this file is first imported and freeze the value to the env fallback
 * (`undefined`, hence `''`, inside a consumer's bundle) before a consumer's
 * `config.lobPublishableKey` could land.
 *
 * Still resolves to `''` rather than `undefined` when unconfigured, which callers treat
 * as "address verification unavailable".
 */
export const getLobPublishableKey = (): string => getConfig('lobPublishableKey');

export const LOB_API_BASE_URL = 'https://api.lob.com/v1';
